<template>
  <div class="uk-grid main-container">
    <div class="uk-width-1-1 uk-text-center heading-container">
      <h1 class="uk-heading-primary uk-text-bold">{{$t('noResultError.sorry')}}</h1>
    </div>
    <div class="uk-width-1-1 uk-text-center uk-margin-small description-container">
      <p class="description" id="errorterm">{{$t('noResultError.noResources')}}</p>
    </div>
    <div class="uk-width-1-1 search-container">
      <h2>{{$t('noResultError.searchTips')}}</h2>
      <div class="list">
        <ul class="a">
          <li type="disc" class="a">{{$t('noResultError.checkSpelling')}}</li>
          <li type="disc" class="a">{{$t('noResultError.simpleTerms')}}</li>
          <li type="disc" class="a">{{$t('noResultError.lessSpecific')}}.</li>
          <li type="disc" class="a">{{$t('noResultError.browsing')}} <a @click="redirect">{{$t('noResultError.mostPopularResources')}}</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import Router from '../../router/index'
  import * as sorting from '../../enums/sorting'

  export default {
    name: 'search-error-item',
    props: ['term'],
    computed: {
      ...mapGetters(['searchTerm', 'sorting', 'filters'])
    },
    methods: {
      ...mapMutations(['updateSorting']),
      ...mapActions(['setDefaultFilters']),
      redirect() {
        this.sorting.items.map(s => {
          s.selected = s.id === sorting.SORT_BY_MOST_POPULAR
        })
        this.setDefaultFilters(this.filters)
        this.updateSorting(this.sorting)
        Router.push('search')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  a {
    color: $content-link-blue;
  }

  .description-container {
    padding: 0;
  }

  .main-container {
    margin-left: 8.57%;
    width: 82.85%;
    margin-right: calc(100% - 8.57%);
  }

  .search-container {
    margin: 35px 0 47px 25%;
  }

  .list {
    text-align: left;
    width: 72%;
  }

  h2 {
    color: rgba(0, 1, 2, 0.7);
    margin: 0 0 0 0;
    line-height: 26px;
    font-size: 24px;
    font-weight: bold;
  }

  ul.a {
    line-height: 26px;
    font-size: 20px;
    color: rgba(0, 1, 2, 0.7);
    list-style-type: circle;
  }

  .heading-container {
    margin: 47px 90.5px 0 90.5px;
    padding: 0;
  }

  .custom-button {
    margin-top: 30px;
    margin-bottom: 71px;
    width: 254px;
    height: 44px;
    border-radius: 2px;
    border: solid 2px #7a8b99;
    font-weight: bold;
    font-size: 20px;
    color: #7a8b99;
  }

  .uk-heading-primary {
    color: rgba(0, 1, 2, 0.7);
    line-height: 42px;
    font-size: 36px;
    text-align: center;
  }

  .heading {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.17;
    color: rgba(0, 1, 2, 0.7);
  }

  .description {
    line-height: 36px;
    font-size: 24px;
    color: rgba(0, 1, 2, 0.7);
    margin-bottom: 0;
    margin-top: 0;
  }

  .uk-margin-small {
    margin: 20px 20px 0px 20px;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .search-container {
      margin-left: 0;
      margin-bottom: 5px;
      margin-top: 0px;
    }
    .description {
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .heading-container {
      margin: 0 0 0 0;
      padding-top: 24px;
    }
    .uk-heading-primary {
      margin: 24px 31.13px 0 31.13px;
      width: 236px;
      font-size: 24px;
      line-height: 33.6px;
      display: inline;
    }
    h2 {
      line-height: 16.6px;
      font-size: 12.8px;
    }
    .description {
      line-height: normal;
      font-size: 14px;
    }
    ul.a {
      line-height: 16.6px;
      font-size: 12.8px;
    }
    .list {
      text-align: left;
      width: 100%;
    }
    .custom-button {
      margin-top: 16px;
      margin-bottom: 40px;
    }
    .text-spacer {
      margin-top: 10px;
    }
  }
</style>
